<template>
<div v-if="currentTx">
  <item title="Date" :description="formattedDate" />
  <divider />
  <item title="Smart Contract & Action" :description="currentTx.action_trace.act.account +' / '+ currentTx.action_trace.act.name" />
  <divider />
  <item title="Sender" >
    <tx-auth :items="currentTx.action_trace.act.authorization" />
  </item>
  <divider />
  <item title="Receiver" :description="currentTx.action_trace.receipt.receiver" />
  <divider />
  <item title="Quantity" :description="currentTx.action_trace.act.data.quantity || 'N/A'" />
  <divider />
  <item title="Memo" :description="currentTx.action_trace.act.data.memo || currentTx.action_trace.act.data.message" />
  <divider />
  <item title="Data">
    <pre class="is-black">{{currentTx.action_trace.act.data}}</pre>
  </item>
</div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import Item from '@/components/general/sidebar-section'
import JobRow from '@/components/jobs/job-row-card'
import Divider from '@/components/general/divider'
import TxAuth from '@/components/wallet/tx/Auth'

export default {
  components: { JobRow, Item, Divider, TxAuth },
  props: {
    transaction: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState('walletTx', ['currentTx']),
    ...mapGetters('jobs', [
      'jobById'
    ]),
    job () {
      if (!this.transaction) { return null }
      return this.jobById(this.transaction.job)
    },
    formattedDate () {
      if (!this.currentTx) { return '' }
      return moment(this.currentTx.block_time).format('DD MMM YY, hh:mm A')
    },
    amount () {
      return this.currentTx ? this.currentTx.action_trace.act.data.quantity : 'N/A'
    },
    total () {
      return this.transaction ? this.transaction.total : ''
    },
    status () {
      return this.transaction ? this.transaction.status : ''
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .text-block {
    line-height: 1
  }
</style>



// WEBPACK FOOTER //
// src/components/wallet/transaction-details.vue